<script>
import deploymentProgress from '../services/DeploymentProgressService/deploymentProgress';

export default {
  name: 'deployment-progress',

  async mounted() {
    await this.get();
  },
  data() {
    return {
      getData: {},
      dataTask: [],
      readMoreActivated: false,
      arrayReadMore: [],
      statusBar: []
    };
  },
  methods: {
    async get() {
      // this.getData = await deploymentProgress.getAll();
      const data = await deploymentProgress.getAll();
      let dataTemp = [];

      data.forEach(doc => {
        const item = {
          description: doc.get("Description"),
          progress: doc.get("Progress"),
          tasks: doc.get("Tasks"),
          arquivo: doc.get("idArquivo"),
          icon: doc.get("Icon"),
        };
        dataTemp.push(item);
      });

      dataTemp = dataTemp.map(item => {
        let successCount = item.tasks.reduce((item1, item2) => {
          if (item2.Status === 1) {
            return item1 + 1;
          }
          return item1;
        }, 0);
        return {
          ...item,
          porcentagem: this.getStatus(successCount, item.tasks.length)
        }
      });

      this.getData = dataTemp;

      console.log('dataTemp', dataTemp);
      const tt = dataTemp.map(item => item.tasks);

      console.log('tasks', tt)

      this.dataTask = this.getData.map(item => item.tasks)
    },
    activateReadMore() {
      this.readMoreActivated = true;
    },
    disableReadMore() {
      this.readMoreActivated = false;
    },
    async downloadPDF(file) {
      try {
        const path = "deployment_progress/";
        await deploymentProgress.downloadPeriodicInformation(file, path);
      } catch (e) {
        console.log("Erro ao fazer download do pdf", e);
      }
    },
    addReadMore(id) {
      this.arrayReadMore.push(id);
      this.activateReadMore();
    },
    addReadLess(id) {
      this.arrayReadMore = this.arrayReadMore.filter(item => item !== id);
      this.disableReadMore();
    },
    getStatus(succes, total) {
      let count = (succes / total) * 100;
      return Math.round((this.statusBar = count));
    }
  },
};
</script>

<template>
  <div class="container-fluid deployment-progress">
    <header class="row">
      <div class="col-12">
        <div class="row content-header">
          <div class="col-xs-12 col-md-5">
            <img src="../assets//images/logoreunivest.png" alt="logo" class="logo" />
          </div>
          <div class="col-xs-12 col-md-7" style="padding-left: 0;">
            <p class="title-logo">Progresso de implantação <span></span></p>
          </div>
        </div>
      </div>
    </header>

    <div class="">
      <div class="cards">
        <div class="card card-infos" v-for="item in  getData" :key="item.description">
          <header>
            <div class="row mb-4" style="display: flex; align-items: center;">
              <img :src="item.icon" alt="" class="pr-2 pl-3" />
              <p class="title-card">{{ item.description }}</p>
            </div>

            <div
              class="progress"
              role="progressbar"
              aria-label="Example with label"
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
              style="background-color: rgba(224, 80, 42, 0.20);"
            >
              <div 
                class="progress-bar" 
                :style="{ 'width': item.porcentagem + '%' }"
                style="background-color: #E0502A; border-radius: 7px;"
              >
                {{ item.porcentagem }}%
              </div>
            </div>
          </header>

          <div class="timeline p-4 block mb-4">
            <div class="tl-item" v-for="itemTasks in  item.tasks " :key="itemTasks.Title">
              <div
                class="tl-dot"
                :class="{
                  bSuccess, dotSuccess: Number(itemTasks.Status === 1),
                  bDanger, dotDanger: Number(itemTasks.Status === 2),
                  bDefault, dotDefault: Number(itemTasks.Status === 3 || itemTasks.Status === 0 || itemTasks.Status >= 4 || itemTasks.Status.length === 0),
                }">
              </div>
              <div class="tl-content">
                <!-- {{ getStatus(itemTasks.Status === 1, itemTasks.Status.length) }} -->
                <div>{{ itemTasks.Title }}</div>
                <div class="tl-desc mt-1" v-if="itemTasks.Description.length >= 66">
                  <div v-if="arrayReadMore.indexOf(Number(itemTasks.id)) < 0">
                    {{ itemTasks.Description.slice(0, 65) }}
                    <a
                      class="readmore"
                      v-if="arrayReadMore.indexOf(Number(itemTasks.id)) < 0"
                      @click="addReadMore(Number(itemTasks.id))"
                      href="#"
                    >
                      Ler Mais...
                    </a>
                  </div>

                  <div>
                    <span
                      v-if="arrayReadMore.indexOf(Number(itemTasks.id)) >= 0"
                      v-html="itemTasks.Description"
                    ></span>
                    <a
                      class="readmore"
                      v-if="arrayReadMore.indexOf(Number(itemTasks.id)) >= 0"
                      @click="addReadLess(Number(itemTasks.id))"
                      href="#"
                    >
                      Ler Menos.
                    </a>
                  </div>
                </div>
                <div class="tl-desc mt-1" v-if="itemTasks.Description.length < 66">
                  {{ itemTasks.Description}}
                </div>
                <div
                  class="container-file"
                  :class="{
                    downloadItem: itemTasks.file === 1
                  }"
                  @click="downloadPDF(itemTasks.file)"
                >
                  <svg 
                    v-if="itemTasks.file"
                    width="18"
                    height="23"
                    viewBox="0 0 18 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd" 
                      clip-rule="evenodd"
                      d="M11.25 0H2.25C1.008 0 0 1.0304 0 2.3V20.7C0 21.9696 1.008 23 2.25 23H15.75C16.992 23 18 21.9696 18 20.7V6.9L11.25 0ZM4.52475 16.9096C4.52475 18.0147 4.00612 18.4 3.17475 18.4C2.97675 18.4 2.718 18.3666 2.54813 18.308L2.64488 17.6007C2.76187 17.641 2.91375 17.6698 3.08475 17.6698C3.44362 17.6698 3.66975 17.503 3.66975 16.8993V14.459H4.52588V16.9096H4.52475ZM5.09175 18.1585C5.30438 18.2793 5.733 18.3943 6.16613 18.3943C7.20788 18.3943 7.6995 17.8423 7.69838 17.1914C7.69838 16.6439 7.38338 16.2875 6.71288 16.0345C6.22125 15.8447 6.0075 15.7343 6.0075 15.4871C6.0075 15.2858 6.18863 15.1133 6.55988 15.1133C6.93113 15.1133 7.20113 15.2226 7.353 15.2973L7.5465 14.59C7.31925 14.4854 7.00537 14.3934 6.57788 14.3934C5.68237 14.3934 5.14125 14.9005 5.14125 15.563C5.14125 16.1264 5.55188 16.4841 6.18412 16.7084C6.63975 16.8751 6.81862 17.0131 6.81862 17.2558C6.81862 17.5076 6.61163 17.6755 6.21788 17.6755C5.85225 17.6755 5.49563 17.5536 5.26613 17.4328L5.09175 18.1585ZM9.88538 18.4C8.75925 18.4 8.10112 17.5317 8.10112 16.4266C8.10112 15.2628 8.82788 14.3934 9.94837 14.3934C11.1128 14.3934 11.7495 15.2858 11.7495 16.3565C11.7484 17.6295 10.9946 18.4 9.88538 18.4ZM14.5485 18.3368H15.4508H15.4519V14.459H14.6621V15.5917C14.6621 16.1736 14.679 16.6968 14.7353 17.2086H14.7195C14.5485 16.7716 14.3235 16.2875 14.0985 15.8804L13.3099 14.459H12.3075V18.3379H13.0961V17.1695C13.0961 16.5359 13.0849 15.9885 13.0612 15.4767L13.0793 15.471C13.266 15.9252 13.5124 16.4266 13.7374 16.8395L14.5485 18.3368ZM11.25 8.05H10.125V2.3L15.75 8.05H11.25ZM9.00788 16.4082C9.00788 15.6549 9.34425 15.0903 9.92588 15.0903C10.5165 15.0903 10.8439 15.6906 10.8439 16.3852C10.8439 17.1396 10.512 17.7031 9.93038 17.7031C9.35775 17.7031 9.00788 17.1684 9.00788 16.4082Z"
                      fill="#FF9F43"
                    />
                  </svg>
                  <p>{{ itemTasks.file }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.deployment-progress>header {
  background-color: #07123c;
  height: 231px;
  padding-top: 55px;
}

.logo {
  margin-left: 220px;
}

.title-logo {
  color: #fff;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.title-logo span {
  font-weight: 700;
}

.title-card {
  font-family: Quicksand;
  color: #07123c;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: initial;
  padding: 0;
  margin: 0;
  flex: min-content;
}

.cards {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 40px;

  margin-top: -100px;
  text-transform: initial;
  flex-wrap: wrap;
}

.card-infos {
  display: flex;
  width: 450px;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
}

.downloadItem {
  display: flex;
  gap: 10px;
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 25px;
}

.downloadItem p {
  color: #07123C;
  font-family: Quicksand;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  margin: 0;
}

.readmore {
  color: #3250E6;
  font-family: Quicksand;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  cursor: pointer;
}

.card-infos header {
  width: 100%;
  margin-bottom: 10px;
}

/*PROGRESS*/

.timeline {
  position: relative;
  border-color: rgba(160, 175, 185, 0.15);
  padding: 0;
  margin: 0;
  margin-top: -40px;
}

.p-4 {
  padding: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.tl-item {
  border-radius: 3px;
  position: relative;
  display: -ms-flexbox;
  display: flex;
}

.tl-item>* {
  padding: 10px;
}

.tl-item:last-child .tl-dot:after {
  display: none;
}

.tl-item:last-child .tl-dot:after {
  display: none;
}

.tl-item .dotSuccess:before {
  border-color: #10b52a;
  box-shadow: 0 0 0 4px rgba(68, 139, 255, 0.2);
}

.tl-item .dotDanger:before {
  border-color: #e0502a;
  box-shadow: 0 0 0 4px rgba(255, 112, 68, 0.2);
}

.tl-item .dotDefault:before {
  border-color: #989898;
  box-shadow: 0 0 0 4px rgba(68, 139, 255, 0.2);
}

.tl-dot {
  position: relative;
  border-color: rgba(160, 175, 185, 0.15);
}

.tl-dot:after,
.tl-dot:before {
  content: '';
  position: absolute;
  border-color: inherit;
  border-width: 2px;
  border-style: solid;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
}

.tl-dot:after {
  width: 0;
  height: auto;
  top: 25px;
  bottom: -15px;
  border-right-width: 0;
  border-top-width: 0;
  border-bottom-width: 0;
  border-radius: 0;
}

.tl-dot {
  position: relative;
  border-color: rgba(160, 175, 185, 0.15);
}

.tl-dot:after,
.tl-dot:before {
  content: '';
  position: absolute;
  border-color: inherit;
  border-width: 2px;
  border-style: solid;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
}

.dotSuccess:after,
.dotSuccess:before {
  background-color: #10b52a;
}

.dotDanger:after,
.dotDanger:before {
  background-color: #e0502a;
}

.dotDefault:after,
.dotDefault:before {
  background-color: #989898;
}

.tl-dot:after {
  width: 0;
  height: auto;
  top: 25px;
  bottom: -15px;
  border-right-width: 3px;
  border-top-width: 0;
  border-bottom-width: 0;
  border-radius: 0;
}

.tl-content p:last-child {
  margin-bottom: 0;
}

.tl-title {
  /* font-size: 0.85em; */
  font-size: 16px;
  font-weight: 500;
  line-height: 23px;
  letter-spacing: 0px;
  text-transform: initial;
  font-family: Quicksand;
}

.tl-desc {
  font-size: 16px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0px;
  color: #7a7a7a;
  font-family: Quicksand;

}

.bDefault {
  border-color: #989898 !important;
}

.bDanger {
  border-color: #e0502a !important;
}

.bSuccess {
  border-color: #10b52a !important;
}
/*end-progress*/
.container-file {
  margin-top: 10px;
  cursor: pointer;
  display: flex;
  gap: 10px;
}


@media screen and (max-width: 969px) {
  .content-header div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
  }

  .logo {
    margin-left: 0;
    margin-bottom: 20px;
  }

  .cards {
    margin-top: -80px;
  }
}
</style>
